import { useAppSelector } from "@/store/hooks"
import gsap from "gsap"
import { images } from "@/utils/data"
import React, { useEffect, useRef } from "react"
import houseDropAudioFile from "@/audio/house-drop.mp3"
import houseRemoveAudioFile from "@/audio/property-card-movement.mp3"
import { activeTimings } from "@/utils/animationSpeed"
import { createEffectAudio } from "@/utils/audioManager"

interface HouseItemOriginalProps {
  index: number
  propertyOrder: number
}
const HouseItemOriginal: React.FC<HouseItemOriginalProps> = ({
  index,
  propertyOrder,
}) => {
  // One of these sits on every board cell, so this reads only the two values it
  // animates off rather than subscribing to the whole slice.
  const propChangesAppliedAnimation = useAppSelector(
    (state) => state.global.animationData.propChangesAppliedAnimation
  )
  const tempCount = useAppSelector((state) => state.global.tempCount)
  const ref = useRef<HTMLImageElement | null>(null)
  //
  //   "House animation data",
  //   propChangesAppliedAnimation
  // )

  useEffect(() => {
    if (!ref.current) return
    const myAnimationData =
      propChangesAppliedAnimation.houseAnimations.find(
        (item) => item.index === index && item.propertyOrder === propertyOrder
      )

    if (!myAnimationData) return
    if (myAnimationData.type === "add") {
      const timeline = gsap.timeline({})
      const initXValues = [0, 0, 0, 0]
      const delay =
        myAnimationData.delay * (activeTimings().houseAddDelay / 1000)
      timeline

        .set(ref.current, {
          scale: 5,
          y: -700,
          opacity: 0,
        })
        .to(ref.current, {
          opacity: 1,
          duration: 0.0001,
          delay: delay === 0 ? undefined : delay,
          onComplete: () => {
            const jailDropAudio = createEffectAudio(houseDropAudioFile)
            jailDropAudio.play()
          },
        })
        .to(ref.current, {
          scale: 1,
          duration: activeTimings().houseAdd / 1000,
          y: 0,
          ease: "bounce",
          onComplete: () => {
            // dispatch({
            //   removeAddHouseAnimationItem: {
            //     index: index,
            //     propertyOrder: propertyOrder,
            //   },
            // })
          },
        })
    }
    if (myAnimationData?.type === "remove") {
      const timeline = gsap.timeline({})
      const initXValues = [0, 0, 0, 0]
      const delay =
        (activeTimings().houseRemoveDelay / 1000) * myAnimationData.delay
      timeline

        // .to(ref.current, {
        //   delay: delay,
        //   duration: 0,
        //   scale: 1,
        //   y: 0,
        //   x: 0,
        //   opacity: 1,
        // })
        .to(ref.current, {
          opacity: 1,
          x: 0,
          y: 0,
          duration: 0.0001,
          delay: delay === 0 ? undefined : delay,
          onComplete: () => {
            const jailDropAudio = createEffectAudio(houseRemoveAudioFile)
            jailDropAudio.play()
          },
        })
        .to(ref.current, {
          scale: 2,
          duration: activeTimings().houseRemove / 1000,
          y: -1000,
          x: -2000,
          ease: "power3.inOut",
        })
    }
  }, [
    index,
    propertyOrder,
    propChangesAppliedAnimation,
    tempCount,
  ])

  // useEffect(() => {
  //   if (!ref.current) return
  //   const myAnimationData = state.animationData.removeHouseAnimations.find(
  //     (item) =>
  //       item.index === index && item.propertyOrder === item.propertyOrder
  //   )
  //   if (myAnimationData) {
  //     const timeline = gsap.timeline({})
  //     const initXValues = [0, 0, 0, 0]
  //     const delay = 0.1 * myAnimationData.delay
  //     timeline
  //
  //       .set(ref.current, {
  //         scale: 1,
  //         y: 0,
  //         x: 0,
  //         opacity: 0,
  //       })
  //       .to(ref.current, {
  //         opacity: 1,
  //         duration: 0.0001,
  //         delay: delay === 0 ? undefined : delay,
  //         onComplete: () => {
  //           const jailDropAudio = new Audio(houseRemoveAudioFile)
  //           jailDropAudio.play()
  //         },
  //       })
  //       .to(ref.current, {
  //         scale: 2,
  //         duration: 1.5,
  //         y: -1000,
  //         x: -2000,
  //         ease: "power3.inOut",
  //         onComplete: () => {
  //           dispatch({
  //             setAnimationData: {
  //               removeHouseAnimations:
  //                 state.animationData.removeHouseAnimations.filter(
  //                   (item) =>
  //                     !(
  //                       item.propertyOrder === propertyOrder &&
  //                       item.index === index
  //                     )
  //                 ),
  //             },
  //           })
  //         },
  //       })
  //   }
  // }, [
  //   index,
  //   propertyOrder,
  //   state.animationData.removeHouseAnimations,
  //   tempCount,
  // ])
  // Height is owned by `.cell .cell-color img` in App.css (--house-size /
  // --hotel-size), which outranks any height utility written here — the strip
  // has to size its own contents because four houses share one cell's width.
  // `hotel-item` is what lets that CSS give the lone hotel the bigger of the two.
  return index === 4 ? (
    <img
      ref={ref}
      className="hotel-item relative drop-shadow-[4px_4px_4px_black] w-auto z-[60]"
      src={images.hotelImage}
    ></img>
  ) : (
    <img
      ref={ref}
      className="relative drop-shadow-[4px_4px_4px_black] w-auto z-[60]"
      src={images.houseImage}
    ></img>
  )
}
export default React.memo(HouseItemOriginal)
